import { render } from "./TemplateVCH.vue?vue&type=template&id=df195e66"
import script from "./TemplateVCH.vue?vue&type=script&lang=js"
export * from "./TemplateVCH.vue?vue&type=script&lang=js"
script.render = render

export default script